import React from "react";

export default function Loading() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
      }}
    >
      <div className="spinner-border text-danger" role="status">
        <span className="visually-hidden">Loading ...</span>
      </div>
    </div>
  );
}
